export default {
  strict: true,
  namespaced: true,
  state: {
    stack: [],
    options: {},
    slides: [],
    currentSliderIndex: 0,
    isShowMenu: false,
    isShowLoding: false,
    slideTimer: null,
  },
  mutations: {
    push(state, page) {
      state.stack.push(page);
    },
    pop(state) {
      if (state.stack.length > 1) {
        state.stack.pop();
      }
    },
    replace(state, page) {
      state.stack.pop();
      state.stack.push(page);
    },
    reset(state, page) {
      state.stack = [page || state.stack[0]];
    },
    options(state, newOptions = {}) {
      state.options = newOptions;
    },
    toggleMenu(state, value) {
      state.isShowMenu = value;
    },
    setSlides(state, value) {
      state.slides = value;
    },
    switchCurrentSlideIndex(state, index) {
      state.currentSliderIndex = index;
    },
    startSlideTimer(state) {
      state.slideTimer = setInterval(() => {
        if (state.currentSliderIndex === state.slides.length - 1) {
          state.currentSliderIndex = 0;
        } else {
          state.currentSliderIndex += 1;
        }
      }, 5000);
    },
    stopSlideTimer(state) {
      clearInterval(state.slideTimer);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/modules/navigator/home_navigator.js